<div>
    <p-table class="report-table" #dt [value]="data" dataKey="id"[paginator]="false" [showCurrentPageReport]="true" 
    [scrollable]="true" scrollHeight="430px">
        <ng-template pTemplate="header">
            <tr>
                <ng-container *ngFor="let item of header">
                    <th>
                        {{item.title}}
                    </th>
                </ng-container>
                <!-- <th class="action">
                    action
                </th> -->
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-i="rowIndex" let-Data let-editing="editing" >
            <tr [pSelectableRow]="Data">
                <ng-container *ngFor="let key of header">
                    <td *ngIf="key.key == 'status'">
                        <p-tag [value]="Data.status.label" [severity]="Data.status.class" />
                    </td>
                    <td  *ngIf="key.key != 'status' && !key.currencyPipe">{{ Data[key.key] }}</td>
                    <td  *ngIf="key.key != 'status' && key.currencyPipe">{{ Data[key.key] | currency : ' ' : 'symbol-narrow' : '1.2-2'}}</td>
                </ng-container>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr *ngIf="!loading" >
                <td [attr.colspan]="header.length + 1">
                    <div class="nodata">
                        <div class="not-found py-4 w-100">
                            <img src="assets/images/no-data.png" alt="">
                            <span class="mt-4 d-block">No data available</span>
                        </div>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

